<template>
	<div>
		<!-- 轮播图 -->
		<el-carousel height="569px">
		  <el-carousel-item v-for="(item, index) in bannerList" :key="index">
		    <img style="width: 100%;height: 569px;" :src="item"/>
		  </el-carousel-item>
		</el-carousel>
		
		<!-- 成长历程 -->
		<div class="container">
			<div class="content" style="margin-bottom: 120px;">
				<div style="text-align: center;font-size: 28px;line-height: 60px;margin: 60px 0;">用数据见证中雅的点滴成长</div>
				<div style="display: flex;justify-content: space-between;margin-top: 60px;">
					<div v-for="item in numberData" style="display: flex;justify-content: center;flex-wrap: wrap;text-align: center;">
						<i class="mw-iconfont w-button-icon" style="width: 100%;font-size: 40px;color: #333;">{{item.icon}}</i>
						<div style="width: 100%;font-size: 36px;color: #333;margin-top: 30px;">{{item.number}}</div>
						<div style="color: #666;font-size: 16px;">{{item.name}}</div>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 关于我们 -->
		<div class="container" style="background-color: rgb(238, 238, 238);">
			<div class="content" style="display: flex;justify-content: space-between;padding-top: 100px;padding-bottom: 100px;align-items: center;">
				<div style="width: 515px;background-color: #586971;color: white;padding: 36px;border-radius: 5px;">
					<div style="width: 515px;margin-bottom: 28px;font-size:28px">关于我们</div>
					<div style="width: 515px;line-height: 1.75;font-size: 12px;">
						公司从事印尼清关行业已有7年之久 2017年开始服务于印尼tanah abang  blok f 市场围巾产品的resmi清关运输服务，2018年开通了印尼散货拼柜服务运输产品涉及、纺织品、服装、童装、花边、鞋子、劳保用品、文具、塑料制品、五金工具、机器、电子产品、宠物用品、食品、化妆品、药品、床上用品、等各类百货、服务客户覆盖、电商、Tik Tok、虾皮、 独立站、Lazada、tokopedia、及线下批发商等各类客户，至今公司一直专注印尼清关的resmi、灰清清关业务、针对不同品类的货物清关及手续的合规化、促使清关时间，效率的高效性、保障每位客户的货物能够及时安全的到达！
						目前公司在义乌、广州两个地区均设有仓库、收货、装箱、报关、海运集拼服务
						在印尼雅加达地区设有专属仓库，拥有自己的派送运输货车数辆、中国管理人员两人，印尼籍员工15人、专注服务客户的派送及客服服务。经过7年的时间的沉淀公司累计了数百位优质客户，2023公司在义乌成立了义乌市中雅网络科技有限公司，结合前期的经验公司拥有自主开发系统能力，为印尼清关运输业务开发了，“中印国际物流”物流跟踪app提供客户物流入仓、装柜、海运、到港、派送等信息化点位的跟踪和关注、也为公司部分客户提供了开发订制系统、简化工作流程提高各项工作效率！   
					</div>
				</div>
				<div style="width: 464px;">
					<div v-for="(item, index) in aboutData" style="display: flex;align-items: center;" :style="index < aboutData.length - 1 ? {marginBottom: '70px'} : {}">
						<i class="mw-iconfont w-button-icon" style="font-size: 40px;">{{item.icon}}</i>
						<div style="color: #333;margin-left: 40px;">
							<div style="font-size: 16px;">{{item.name}}</div>
							<div style="font-size: 14px;margin-top: 20px;">{{item.content}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 国际海运 -->
		<div class="container">
			<div class="content" style="display: flex;justify-content: space-between;padding-top: 100px;padding-bottom: 100px;align-items: center;">
				<div>
					<div style="font-size: 28px;margin-bottom: 50px;">国际海运</div>
					<div style="line-height: 1.75;font-size: 14px;color: #444;width: 422px;">我们的业务：散货清关：纺织品、服装、童装、围巾、手套、毛巾、地毯、袜子、鞋子、厨具、文具、劳保用品、化工品、五金工具、小家电、建材、塑料制品、等各类小商品的收货、出运、清关业务全程时效16-25天左右、部分产品22-35天.</div>
					<!-- <div style="background-color: red;color: white;cursor: pointer;width: 135px;text-align: center;line-height: 38px;border-radius: 3px;margin-top: 40px;">查看更多航线</div> -->
				</div>
				<div style="display: flex;justify-content: space-between;flex-wrap: wrap;width: 696px;">
					<div class="hover-image-box" v-for="(item, index) in routeImages" style="width: 340px;overflow: hidden;height: 207px;cursor: pointer;" :style="index == 0 ? {marginBottom: '20px'} : {}">
						<img :src="item" style="width: 100%;height: 207px;transition: all 0.3s;"/>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 国际空运 -->
		<div class="container" style="background-color: rgb(238, 238, 238);">
			<div class="content" style="display: flex;justify-content: space-between;padding-top: 100px;padding-bottom: 100px;align-items: center;">
				<div>
					<div style="font-size: 28px;margin-bottom: 50px;">国际空运</div>
					<div style="line-height: 1.75;font-size: 14px;color: #444;width: 422px;">空运业务：除航空公司禁止上飞机货物外 其他各类商品均可空运 时效3-5天！</div>
					<!-- <div style="background-color: red;color: white;cursor: pointer;width: 135px;text-align: center;line-height: 38px;border-radius: 3px;margin-top: 40px;">查看更多航线</div> -->
				</div>
				<div style="display: flex;justify-content: space-between;flex-wrap: wrap;width: 696px;">
					<div class="hover-image-box" v-for="(item, index) in routeFlyImages" style="width: 340px;overflow: hidden;height: 207px;cursor: pointer;background-color: rgb(238, 238, 238);" :style="index == 0 ? {marginBottom: '20px'} : {}">
						<img :src="item" style="width: 100%;height: 207px;transition: all 0.3s;background-color: rgb(238, 238, 238);"/>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 新闻 -->
		<div class="container">
			<div class="content" style="margin-bottom: 80px;">
				<div style="font-size: 28px;text-align: center;margin-top: 100px;margin-bottom: 70px;">新闻资讯</div>
				<div>
					<div v-for="item in newsList" style="display: flex;justify-content: space-between;border-bottom: 1px dotted #ddd;padding: 20px 0;">
						<div style="width: 204px;height: 141px;cursor: pointer;overflow: hidden;" class="hover-image-box">
							<img :src="item.image" style="width: 100%;height: 100%;transition: all 0.3s;"/>
						</div>
						<div style="width: calc(100% - 214px);">
							<div style="font-size: 16px;">{{item.name}}</div>
							<div style="margin-top: 15px;line-height: 1.5;font-size: 14px;color: #666;">{{item.content}}</div>
							<div style="margin-top: 12px;display: flex;justify-content: space-between;font-size: 12px;color: #bbb;">
								<div style="">{{item.date}}</div>
								<div style="align-items: center;">
									<i class="mw-iconfont w-button-icon">넶</i>
									<span style="margin-left: 5px;">{{item.number}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 合作伙伴 -->
		<div class="container" style="background-color: rgb(238, 238, 238);">
			<div class="content" style="margin-bottom: 80px;">
				<div style="font-size: 28px;text-align: center;margin-top: 70px;margin-bottom: 70px;">合作伙伴</div>
				<div style="display: flex;justify-content: space-between;">
					<div class="hover-image-box2" v-for="item in partnerImages" style="width: 278px;height: 133px;background-color: white;display: flex;justify-content: center;align-items: center;transition: all 0.3s;cursor: pointer;">
						<img style="width: 94%;height: 94%;transform: all 0.3s;" :src="item"/>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 联系我们 -->
		<div class="container" style="background-color: rgb(0, 18, 54);color: #666;">
			<div class="content" style="margin-bottom: 56px;">
				<div style="font-size: 28px;text-align: center;margin-top: 70px;">联系我们</div>
				<div style="font-size: 14px;text-align: center;margin-top: 40px;margin-bottom: 40px;">如有任何问题请联系我们，我们7*24小时竭诚为您服务</div>
				<div style="display: flex;justify-content: center;">
					<div class="hover-image-box2" v-for="item in contactList" style="width: 288px;height: 98px;background-color: white;margin: 45px;display: flex;align-items: center;transition: all 0.3s;cursor: pointer;">
						<!-- <i class="mw-iconfont w-button-icon" style="font-size: 40px;color: #ccc;margin: 0 40px;">{{item.icon}}</i> -->
						<img style="width: 40px;height: 40px;margin: 0 40px;" :src="item.image"/>
						<div style="line-height: 2;">
							<div style="font-size: 16px;">{{item.name}}</div>
							<div style="font-size: 14px;">{{item.number}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	
	</div>
</template>

<script>

export default {
	data() {
		return {
			bannerList: ['https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/100240103970.jpg', 'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/100240103970.jpg'],
			numberData: [
				{icon: 'ꁐ', name: '客户的选择', number: '1000+'},
				{icon: 'ꄉ', name: '印尼专线', number: '100+'},
				{icon: 'ꀧ', name: '公司成立', number: '7年+'},
				{icon: 'ꁘ', name: '专业团队', number: '30+'},
			],
			aboutData: [
				// {icon: 'ꁙ', name: '高效', content: '超100条航线，覆盖100多个国家，专业订舱能力，货量足，各大航线舱位稳定，天天装柜时效快。'},
				{icon: 'ꁥ', name: '专业', content: '平均6年以上货代经验，服务快速响应，规范化的报价体系，价格优质透明，根据客户需求，定制最优货运方案。'},
				{icon: 'ꄀ', name: '省心', content: '1对1服务团队，提供上门提货、代理商检、报送等一条龙服务，清关和规避风险能力强，货物准时到达。'},
			],
			routeImages: [
				'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/12/170211684300.png',// 'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/100240103973.png', 
				'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/12/165225115710.png', //'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/100240103974.png', 
				'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/12/165820626850.png',//'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/100240103971.png', 
				'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/12/165956976870.png'//'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/100240103972.png'
			],
			routeFlyImages: [
				'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/12/164840865320.png', //'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/1006178082413.jpg', 
				'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/12/165014474000.png', //'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/100617808249.jpg', 
				'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/12/164552627550.png', //'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/100617808248.jpg', 
				'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/12/165427359070.png'//'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/1006178082410.jpg'
			],
			newsList: [
				{name: '海运费继续下降，欧线暴跌！', image: 'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/100617808240.png', number: '57', date: '2022-11-23', content: '根据上海航运交易所发布的上海出口集装箱综合运价指数的最新数据，从上海港出口到欧洲基本港的市场运价为1172美元/TEU，较上期下跌20.7%'},
				{name: '如何正确的填写报关单？', image: 'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/100240103978.png', number: '81', date: '2020-08-07', content: '为统一进出口货物报关单填报要求，保证报关单数据质量，根据《海关法》及有关法规，制定本规范。  本规范在一般情况下采用“报关单”或“进口报关单”、“出口报关单”的提法，需要分别说明不同要求时。'},
				{name: '海运提单在什么情况下做电放？', image: 'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/100240103977.png', number: '77', date: '2020-05-08', content: '所谓的电放是指托运人(发货人)将货物装船后将承运人(或其代理人)所签发的全套正本提单交回承运人(或其代理人)，同时指定收货人(非记名提单的情况 下)；承运人授权(通常是以电传、电报等通讯方式通知)其在卸货港的代理人，在收货人不出具正本提单(已收回)的情况下交付货物。'},
			],
			partnerImages: [
				'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/100617808245.png', 
				'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/100617808247.png', 
				'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/100617808244.png', 
				'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/100617808246.png'
			],
			contactList: [
				{image: 'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/115327843821.png', name: '微信号', number: '13566791116'},
				{image: 'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/115327843820.png', name: '咨询热线', number: '+8613566791116'},
				{image: 'https://shop-1319179580.cos.accelerate.myqcloud.com/2024/08/10/115327843822.png', name: 'Whatsapp', number: '089518396933'},
			]
		}
	},
	created(){
		
	}
}
</script>

<style>
	
</style>


// WEBPACK FOOTER //
// src/components/home.vue